export function hasPasskeySupport(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") return false;
  return (
    "PublicKeyCredential" in window &&
    !!navigator.credentials &&
    typeof navigator.credentials.create === "function" &&
    typeof navigator.credentials.get === "function"
  );
}

export function toBase64Url(bytes: Uint8Array): string {
  let raw = "";
  for (const b of bytes) raw += String.fromCharCode(b);
  return btoa(raw).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

export function base64UrlToBytes(input: string): Uint8Array {
  const normalized = String(input || "").replace(/-/g, "+").replace(/_/g, "/");
  const padded = normalized + "=".repeat((4 - (normalized.length % 4)) % 4);
  const raw = atob(padded);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i);
  return out;
}

export function toAllowCredentials(ids: string[] | undefined): PublicKeyCredentialDescriptor[] | undefined {
  if (!Array.isArray(ids) || ids.length === 0) return undefined;
  return ids
    .map((id) => String(id || "").trim())
    .filter(Boolean)
    .map((id) => ({
      type: "public-key" as PublicKeyCredentialType,
      id: base64UrlToBytes(id) as unknown as BufferSource
    }));
}

export function readAssertionSignCount(authenticatorData: ArrayBuffer): number {
  const bytes = new Uint8Array(authenticatorData);
  if (bytes.length < 37) return 0;
  return (((bytes[33] << 24) | (bytes[34] << 16) | (bytes[35] << 8) | bytes[36]) >>> 0);
}
